import { Link } from 'react-router-dom';

const footerLinks = {
  navigation: [
    { name: '首页', path: '/' },
    { name: '赛事预测', path: '/category/saishi-yuce' },
    { name: '体育资讯', path: '/category/tiyu-zixun' },
    { name: '运动健康', path: '/category/yundong-jiankang' },
    { name: '电竞专区', path: '/category/dianjing-zhuanqu' },
    { name: '篮球世界', path: '/category/lanqiu-shijie' },
    { name: '竞技分析', path: '/category/jingji-fenxi' },
  ],
  about: [
    { name: '关于我们', path: '/about' },
    { name: '品牌介绍', path: '/about' },
    { name: '荣誉资质', path: '/about' },
    { name: '联系我们', path: '/about' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-50">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-fire-fill text-lg text-background-50"></i>
              </div>
              <span className="font-heading text-lg font-bold tracking-wide text-background-50">开运体育</span>
            </Link>
            <p className="text-foreground-300 text-sm leading-relaxed">
              开运体育是专业的体育竞技与赛事服务平台，涵盖体育资讯、赛事预测、运动健康等全方位内容。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold mb-4 text-background-50">快速导航</h4>
            <ul className="flex flex-col gap-2">
              {footerLinks.navigation.slice(0, 5).map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-foreground-300 hover:text-background-50 text-sm transition-colors">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold mb-4 text-background-50">关于</h4>
            <ul className="flex flex-col gap-2">
              {footerLinks.about.map((link) => (
                <li key={link.name}>
                  <Link to={link.path} className="text-foreground-300 hover:text-background-50 text-sm transition-colors">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold mb-4 text-background-50">联系方式</h4>
            <ul className="flex flex-col gap-3 text-foreground-300 text-sm">
              <li className="flex items-center gap-2">
                <i className="ri-phone-line"></i>
                <span>400-888-6666</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                <span>contact@kaiyunsports.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line"></i>
                <span>北京市朝阳区体育中心</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-foreground-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-400 text-xs">
            &copy; 2026 开运体育 Kaiyun Sports. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-foreground-400 hover:text-background-50 transition-colors" rel="nofollow">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#" className="text-foreground-400 hover:text-background-50 transition-colors" rel="nofollow">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="#" className="text-foreground-400 hover:text-background-50 transition-colors" rel="nofollow">
              <i className="ri-tiktok-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}